import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import progressActions from './progress-actions'

/*

This simply exposes the progressGroups configuration and any component
that needs it (ie the components/current-progress component )

*/

function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        progress: state.progress
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            progress: bindActionCreators(progressActions, dispatch)
        }
    }
}


export function withProgress(Wrapped){

    return connect( mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{
        
        render(){
            return <Wrapped { ...this.props } />
        }
        
    })

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/progress/index.tsx